export default __webpack_public_path__ + "static/media/sign.54df83bc.svg";